// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { rem } from 'polished';
import { IconAlert } from '../../layout/icons';

/**********
 ** Component: ProfileUserAvatar
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const ProfileUserAvatar = props => {
	const renderIconAlert = () => {
		if (props.hasIconAlert) {
			return (
				<div className="alert-icon">
					<NavLink exact={props.exact} to={`${props.to}`} title={`Go to ${props.title}`} activeClassName="is--active">
						<IconAlert bgColor="white" invertColors />
					</NavLink>
				</div>
			);
		}
		return null;
	};
	return (
		<Item>
			<Anchor exact={props.exact} to={`${props.to}`} title={`Go to ${props.title}`} activeClassName="is--active">
				<img
					src={props.photoUrl}
					width="36"
					height="36"
					onError={event => {
						event.target.src =
							'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iTGF5ZXIgMSIgdmlld0JveD0iMCAwIDEzOCAxMzgiPjxwYXRoIGZpbGw9IiNlYmVjZWYiIGQ9Ik0wIDBoMTM4djEzOEgweiIvPjxjaXJjbGUgY3g9IjY3Ljc5IiBjeT0iNTAuOCIgcj0iMjQiIGZpbGw9IiNkMWQyZGIiLz48cGF0aCBmaWxsPSIjZDFkMmRiIiBkPSJNMTkuNzkgMTE1LjY3YzAtMTYuNTYgMzItMjUuNjcgNDgtMjUuNjdzNDggOS4xMSA0OCAyNS42N1YxMzhoLTk2eiIvPjwvc3ZnPg==';
					}}
					className="user-avatar"
					alt={`Go to ${props.title}`}
				/>
			</Anchor>
			{renderIconAlert()}
		</Item>
	);
};

// Styled Components
const fadeInDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-4rem);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const alertScaleIn = keyframes`
  0% {
    transform:scale(0);
  }
	85%{
		transform:scale(1.15);
	}
  100% {
    transform:scale(1);
  }
`;
const Item = styled.li`
	display: inline-flex;
	position: relative;
	width: ${rem('44px')};
	height: ${rem('44px')};
	border-radius: ${rem('44px')};
	list-style-type: none;
	line-height: 100%;
	padding: 0;
	margin-top: 0;
	margin-right: 1rem;
	margin-bottom: 0;
	margin-left: 1rem;
	align-items: center;
	justify-content: center;
	position: relative;
	text-align: center;
	flex-wrap: wrap;
	min-width: ${rem('44px')};
	animation-name: ${fadeInDown};
	animation-duration: 750ms;
	animation-timing-function: ${props => props.theme.easeOutBack};
	animation-fill-mode: forwards;
	animation-delay: 0;
	box-shadow: inset 0px 0px 0px 2px ${props => props.theme.white};
	.alert-icon {
		position: absolute;
		bottom: -8px;
		right: -7px;

		transform: scale(0);
		animation-name: ${alertScaleIn};
		animation-delay: 1500ms;
		animation-duration: 300ms;
		animation-timing-function: ease-out;
		animation-fill-mode: forwards;
	}
`;

const Anchor = styled(NavLink)`
	width: ${rem('36px')};
	height: ${rem('36px')};
	border-radius: ${rem('36px')};
	font-size: 22px;
	letter-spacing: 0.46px;
	color: ${props => props.theme.white};
	font-weight: 600;
	line-height: 100%;
	text-decoration: none;
	align-items: center;
	justify-content: center;
	display: flex;
	overflow: hidden;
	position: relative;
	transition: transform 125ms ease-out;

	img {
		background-color: ${props => props.theme.gray4};
		width: ${rem('36px')};
		height: ${rem('36px')};
		border-radius: ${rem('36px')};
		object-fit: cover;
		object-position: center center;
	}

	&:active {
		outline: 1;
	}
`;

// Prop Types
ProfileUserAvatar.defaultProps = {
	button: false,
	exact: false,
	to: '#',
	title: 'anchor title',
};

ProfileUserAvatar.propTypes = {
	button: PropTypes.bool,
	exact: PropTypes.bool,
	to: PropTypes.string,
	title: PropTypes.string,
};

export default ProfileUserAvatar;



// WEBPACK FOOTER //
// ./src/components/ui/navigation/header/user-avatar.jsx